'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// I guess we need both image and icon styles in this case.
require('ta-semantic-ui/semantic/dist/components/icon.css'); /**
                                                              * @file React component that quickly shows a row of icons or small images.
                                                              * Usually used for visualisations to allow comparing the amount of things.
                                                              *
                                                              * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
                                                              *
                                                              * @version 1.1.0
                                                              * @date 2017-02-22
                                                              *
                                                              */

require('ta-semantic-ui/semantic/dist/components/image.css');

/**
 * React component that quickly shows a row of icons. Usually used for
 * visualisations to allow comparing the amount of things.
 *
 * @param {number} props.count The number of items to show.
 *
 * @param {string} [props.icon='user'] The icon to display. Overriden when
 * props.imageSrc is provided.
 *
 * @param {string} [props.color='grey'] The color of the icons.
 *
 * @param {string} [props.size='large'] The size of the icons. When using
 * images, this should be set to either 'tiny' or 'mini'.
 *
 * @param {boolean} [props.inline=false] If true, puts everything into a 'span'
 * instead of a 'div' element.
 *
 * @param {string} [props.additionalClasses] Additional classes to be
 * provided to the items. As space-delimited strings, just as in normal HTML.
 *
 * @param {string} [props.imageSrc] Use an image instead of an icon.
 *
 * @returns {XML}
 * @constructor
 */
function IconFlood(props) {
  var iconList = [];

  /**
   * Checks whether we use images
   * @type {boolean}
   */
  var useImages = 'imageSrc' in props && props.imageSrc !== '';

  /**
   * Classes and element defaults, for use with icons.
   * @type {string}
   */
  var itemClass = 'ui ' + props.color + ' ' + props.size + ' ' + props.icon + ' ' + props.additionalClasses + ' icon',
      ItemElement = 'i',
      GroupElement = 'div',
      groupClass = 'iconFlood';

  // When using images, use different classes and elements
  if (useImages) {
    itemClass = 'ui image';
    ItemElement = 'img';
    groupClass += ' ui ' + props.size + ' ' + props.additionalClasses + ' images';
  }

  if (props.inline) {
    GroupElement = 'span';
  }

  // Create the list ...
  for (var i = 0; i < props.count; i++) {

    iconList.push(_react2.default.createElement(ItemElement, {
      className: itemClass,
      src: props.imageSrc,
      key: i }));
  }

  return _react2.default.createElement(
    GroupElement,
    { className: groupClass },
    iconList
  );
}

IconFlood.propTypes = {
  count: _react2.default.PropTypes.number.isRequired,
  icon: _react2.default.PropTypes.string,
  color: _react2.default.PropTypes.string,
  size: _react2.default.PropTypes.string,
  inline: _react2.default.PropTypes.bool,
  additionalClasses: _react2.default.PropTypes.string,
  /**
   * @since 1.1.0
   */
  imageSrc: _react2.default.PropTypes.string
};

IconFlood.defaultProps = {
  count: 100,
  icon: 'user',
  color: 'grey',
  size: 'large',
  inline: false,
  additionalClasses: ''
};

exports.default = IconFlood;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-iconflood/dist/index.js
// module id = 132
// module chunks = 0